import Logger, { flatten, serializeLocation } from "@mne-core/logging";
export const logRoute = () => () => {
    Logger.getInstance()?.logInfo("RouteChange", {
        ...flatten(serializeLocation(window.location), { prefix: "location" }),
    });
    return null;
};
